import BaseApi from "./Api";
import { RangeHandicapAccess } from "../types/rangeHandicap";

class RangeHandicapApi extends BaseApi {
  url = "range-handicap";

  constructor() {
    super();
    this.setResourceUrl(this.url);
  }

  getMyAccess = (): Promise<{ data: RangeHandicapAccess }> => {
    return this.instance({
      method: "get",
      url: `${this.resourceUrl}/access/me`,
    });
  };

  setCreatorAccess = (data: { subjectId: string; allowed: boolean }): Promise<{ data: RangeHandicapAccess }> => {
    return this.instance({
      method: "post",
      url: `${this.resourceUrl}/access/grant`,
      data,
    });
  };
}

export default new RangeHandicapApi();
